<template>
    <fieldset>
      <legend class="panel-title"><b-link v-b-toggle.collapse-1 role="button" >Job Posting Location</b-link></legend>
      <b-collapse id="collapse-1">
      <!--<span v-if="processedTeam.length==0" />No filters based on that criteria.</span>-->

        <div v-for="(value, key) in processedLocation" class="input-list" :key="key">
          <label><input type="checkbox" v-bind:id="key" v-bind:value="key"  v-model="checkedNames" v-on:change="getCheckboxeIds()" /> <span>{{ key }} ({{ value }})</span></label>
        </div>
      </b-collapse>
    </fieldset>
</template>


<script>
import { EventBus } from '../event-bus.js';

export default {
  name: 'LocationBox',
  props: ['locationData'],
//   props: {
//     msg: String
//   }
  data: function () {
    return {
      checkedNames: [],
      taxonomyTags: {}
    }
  },
  computed: {
    processedLocation: function() {
      // console.log(this.locationData);
      return this.locationData;
    }
  },
  methods: {
     getCheckboxeIds() {
    //   this.checkedLocationIDstore = this.checkedNames;

    //   this.$parent.getFilteredJobs(this.checkedNames, this.checkedTeamIDstore, this.checkedCommitmentIDstore);
      EventBus.$emit('checkedLocationIDstore', this.checkedNames);
    //   this.$parent.getFilteredJobs();
     },
     uncheckBoxes(){
      //console.log("child");
      this.checkedNames=[];
      EventBus.$emit('checkedLocationIDstore', this.checkedNames);
    //   this.checkedLocationIDstore = [];
     },
     uncheckBox(box){
      var index = this.checkedNames.indexOf(box);
      if (index > -1) {
        this.checkedNames.splice(index, 1);
      }
      EventBus.$emit('checkedLocationIDstore', this.checkedNames);
      // console.log(this.checkedLocationIDstore);
    //   this.$parent.getFilteredJobs(this.checkedLocationIDstore, this.checkedTeamIDstore, this.checkedCommitmentIDstore);
     }
  }
}
</script>
